// hooks/useVersionCheck.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLatestVersion, setCurrentVersion } from '../redux/versionSlice';

const useVersionCheck = (checkInterval = 60000) => {
  const dispatch = useDispatch();
  const { newVersionAvailable, latestVersion } = useSelector((state) => state.version);

  useEffect(() => {
    // Inicializa con la versión guardada en localStorage
    const storedVersion = localStorage.getItem('lastVersionSeen');
    if (storedVersion) {
      dispatch(setCurrentVersion(storedVersion));
    }

    dispatch(fetchLatestVersion());

    const intervalId = setInterval(() => {
      if (document.hidden || newVersionAvailable) return;
      dispatch(fetchLatestVersion());
    }, checkInterval);

    return () => clearInterval(intervalId);
  }, [dispatch, checkInterval, newVersionAvailable]);
};

export default useVersionCheck;
